
      var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgAddToPlaylist = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 32,
  rx: 16,
  fill: "#423F45"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8 10h12M8 22h7M8 16h6",
  stroke: "#fff",
  strokeWidth: 2,
  strokeLinecap: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M22 13a1 1 0 0 1 1 1v3h3a1 1 0 1 1 0 2h-3v3a1 1 0 1 1-2 0v-3h-3a1 1 0 1 1 0-2h3v-3a1 1 0 0 1 1-1Z",
  fill: "#fff"
})));

      const __svgRaw = "<svg width=\"32\" height=\"32\" viewBox=\"0 0 32 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<rect width=\"32\" height=\"32\" rx=\"16\" fill=\"#423F45\"/>\r\n<path d=\"M8 10H20\" stroke=\"white\" stroke-width=\"2\" stroke-linecap=\"round\"/>\r\n<path d=\"M8 22H15\" stroke=\"white\" stroke-width=\"2\" stroke-linecap=\"round\"/>\r\n<path d=\"M8 16H14\" stroke=\"white\" stroke-width=\"2\" stroke-linecap=\"round\"/>\r\n<path d=\"M22 13C22.5523 13 23 13.4477 23 14V17H26C26.5523 17 27 17.4477 27 18C27 18.5523 26.5523 19 26 19H23V22C23 22.5523 22.5523 23 22 23C21.4477 23 21 22.5523 21 22V19H18C17.4477 19 17 18.5523 17 18C17 17.4477 17.4477 17 18 17H21V14C21 13.4477 21.4477 13 22 13Z\" fill=\"white\"/>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/add-to-playlist.36993d289406f41b3dd22296107dd5c9.svg"),
        {
          React: SvgAddToPlaylist,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      